import React from 'react';
import styled from 'styled-components';
import Link from '@mui/material/Link';
import { ReactSVG } from 'react-svg';
import Logo from '../../assets/WesuapLogo.svg';
import LogoWhite from '../../assets/WesuapLogo_white.svg';
import LogoIcon from '../../assets/WesuapIcon.svg';

const MinimalLink = styled(Link)`
  text-decoration: unset !important;
  color: unset !important;
  display: flex;
  ${({ hasIcon }) => hasIcon && 'margin-top: 1.5rem;'}
  ${({ alignment }) => alignment === 'center' && 'justify-content: center;'}
`;

const LogoContainer = styled.div`
  display: flex;
  position: ${({ position }) => position ?? 'relative'};
  align-items: center;
  ${({ width, hasIcon }) => (hasIcon ? '' : `width: ${width ?? 160}px;`)}
  svg {
    width: ${({ width }) => width ?? 160}px;
    height: auto;
  }
`;

export default function HomeLogo({
  alignment,
  position,
  noLink,
  width,
  light,
  icon,
}) {
  return (
    <MinimalLink
      href={!noLink ? '/search' : undefined}
      alignment={alignment}
      hasIcon={!!icon}
    >
      <LogoContainer width={width} position={position} hasIcon={!!icon}>
        <ReactSVG src={icon ? LogoIcon : light ? LogoWhite : Logo} />
      </LogoContainer>
    </MinimalLink>
  );
}
